/* tslint:disable */
/* eslint-disable */
/**
 * Respa
 * The Respa API provides categorized data on resources available for reservation within a city or metropolitan area and enables the reservation of these resources. The API provides data in the JSON format, in a RESTful fashion.
 *
 * The version of the OpenAPI document: 1.6.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TypeName
 */
export interface TypeName {
    /**
     * Resource type in Finnish
     * @type {string}
     * @memberof TypeName
     */
    fi?: string;
}

export function TypeNameFromJSON(json: any): TypeName {
    return TypeNameFromJSONTyped(json, false);
}

export function TypeNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fi': !exists(json, 'fi') ? undefined : json['fi'],
    };
}

export function TypeNameToJSON(value?: TypeName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fi': value.fi,
    };
}


